export const BASE_NAME = null; //"/siig";

export const EMPRESA_NOME = "SIIG TECNOLOGIA";

export const SISTEMA_SIGLA = "SIIG";

export const MAX_LOGO_SIZE_KB = 500 * 1024; // 500 KB
export const MAX_CSV_SIZE_MB = 12 * 1024 * 1024; //2MB
export const MAX_TAMANHO_ARQUIVO_UPLOAD_MB = 45; //tamanho máximo de cada arquivo enviado (anexo e documento)
export const MAX_TAMANHO_TOTAL_ENVIO_MB = 150; //tamanho máximo da soma dos arquivos enviados em uma gravação (cadastro/edição e correção da solicitação, edição do contrato). Os arquivos ficam na memória do servidor até serem gravados
export const MAX_QTDE_ANEXOS_SOLICITACAO = 8; //quantidade máxima de anexos da solicitação
export const MAX_DIAS_ANT_EMISSAO = 90; //máximo de dias da emissão antes do vencimento (geração dos pagamentos no cadastro e na correção da solicitação)
export const MAX_QTDE_ARQUIVOS_PAG_ENVIO = 20; //quantidade máxima de arquivos de cada tipo (documento, forma de pagamento e anexo complementar) dos pagamentos, por gravação do cadastro da solicitação
export const MAX_REG_LOG = 30;

export const COD_ERRO_SESSAO_EXPIRADA = 401;
export const COD_ERRO_REGRA_NEGOCIO = 422;

export const PATH_FERRAMENTA_ADM_SYSTEM = "system";
export const PATH_DEMONSTRACAO = "demonstracao";

export const ORIGEM_LOGIN = {
  SIIG_WEB: "web",
  SIIG_ADM_SYSTEM: "adm_system",
};

export const UUID_GLOBAL = "1940035b-8d4f-4216-a487-0f894fbb7b27";
export const UUID_DEMONSTRACAO = "bdd0b490-a2b0-4f18-ba66-4f7756f2656a";

export const ID_PERFIL_SYSTEM = 1;
export const ID_PERFIL_ADMIN = 2;

export const NOME_PERFIL_SYSTEM = "SYSTEM";
export const NOME_PERFIL_ADMIN = "ADMIN";

export const ID_USUARIO_SYSTEM = 1;

export const NOME_USUARIO_SYSTEM = "SYSTEM";
export const NOME_USUARIO_ADMIN = "ADMIN";

export const IDENTIFICACAO_USUARIO_SYSTEM = "system";
export const IDENTIFICACAO_USUARIO_SYSTEM_DEV = "system_dev"; //usuário fictício. Loga com senha do system
export const IDENTIFICACAO_USUARIO_ADMIN = "admin";

//Posição do menu do sistema (no topo ou na lateral esquerda)
export const POSICAO_MENU = {
  TOPO: "T",
  LATERAL: "L",
};

export const ID_FORNECEDOR_NAO_IDENTIFICADO = 0;
export const CODIGO_FORNECEDOR_NAO_IDENTIFICADO = 0;

export const DESCRICAO_REGRA_SENHA =
  "A senha deve ter no mínimo 6 caracteres e conter letra e número";

export const SHOW_DESC_OBRIGATORIO_FIELDS = false;

export const MAX_DIAS_EDITAR_SOLICITACAO_REJEITADA = 1;

export const FORMATACAO_CODIGO = {
  EMPRESA: 3,
  FILIAL: 3,
  CENTRO_CUSTO: 4,
  FORNECEDOR: 6,
  USUARIO: 6,
};

export const TEMA_PADRAO = {
  header_footer_background: "#786e64",
  header_footer_color: "#ffffff",

  title_color: "#d8840e",

  table_striped: "S",
  table_header_background: "#ffffff",
  table_header_color: "#d8840e",

  primary_background: "#d8840e",
  primary_color: "#ffffff",

  secondary_background: "#786e64",
  secondary_color: "#ffffff",
};

export const TEMA_SYSTEM = {
  header_footer_background: "#5a5a61",
  header_footer_color: "#ffffff",

  title_color: "#426cb9",

  table_striped: "S",
  table_header_background: "#ffffff",
  table_header_color: "#426cb9",

  primary_background: "#426cb9",
  primary_color: "#ffffff",

  secondary_background: "#5a5a61",
  secondary_color: "#ffffff",
};

export const TEMA_DEMONSTRACAO = {
  header_footer_background: "#516e53", //"#0f4e67"
  header_footer_color: "#ffffff",

  title_color: "#944128",

  table_striped: "S",
  table_header_background: "#ffffff",
  table_header_color: "#0f4e67",

  primary_background: "#516e53",
  primary_color: "#ffffff",

  secondary_background: "#786e64",
  secondary_color: "#ffffff",
};

export const AMBIENTE_NF = {
  PRODUCAO: "1",
  HOMOLOGACAO: "2",
};

export const TIPO_IMPORTACAO = {
  RESUMO_VENDA_GRUPO: 1,
  RESUMO_VENDA_QTDE_CLIENTE: 2,
  FORNECEDOR: 3,
  NOTA_FORNECEDOR: 4,
  META_EMPRESA: 5,
  QTDE_COLAB_CENTRO_CUSTO: 6,
  //INDICE_REAJUSTE_PERC: 7,
};

export const CONFIG_IMPORTACAO = {
  extensao: "csv",
  delimitador: ";",
  desc_delimitador: " ; (ponto e vírgula)",
  tamanho_max: null,
};

//Valores do campo tipo da tabela FERIADO
export const TIPO_FERIADO = {
  NACIONAL: "N",
  MUNICIPAL: "M",
  ESTADUAL: "E",
};

//Valores do campo tipo da tabela PERFIL
export const TIPO_PERFIL = {
  SYSTEM: "S",
  ADMINISTRATIVO: "A",
  LOJA: "L",
};

//Tipos de log do servidor (tela Sys Consulta > Log servidor)
export const TIPO_LOG_SERVIDOR = {
  PM2_ERRO: "PE", //Arquivo de erro do pm2
  PM2_ACOMPANHAMENTO: "PA", //Arquivo de output do pm2
  APLICACAO_ERRO: "AE", //Arquivo de erro da aplicação (winston), com cliente, usuário, rota e IP
  APLICACAO_GERAL: "AG", //Arquivo geral da aplicação (winston), com cliente, usuário, rota e IP
};

//Situação do usuário na consulta de usuários conectados (SIIG Administrativo)
export const SITUACAO_USUARIO_CONECTADO = {
  CONECTADO: "C", //Última atividade dentro do limite do cliente
  SEM_ATIVIDADE: "S", //Sessão válida, mas sem atividade recente (provavelmente fechou a aba)
};

//Valores do campo tipo da tabela USUARIO
export const TIPO_USUARIO = {
  SYSTEM: "S",
  ADMINISTRATIVO: "A",
  LOJA: "L",
};

//Valores do campo situacao da tabela USUARIO
export const SITUACAO_USUARIO = {
  ATIVO: "A",
  INATIVO: "I",
};

//Valores do campo tipo da tabela FILIAL
export const TIPO_FILIAL = {
  ADMINISTRATIVA: "A",
  CENTRO_DISTRIBUICAO: "C",
  LOJA: "L",
};

//Valores do campo tipo da tabela CENTRO_CUSTO
export const TIPO_CENTRO_CUSTO = {
  LOJA: "L",
  ADMINISTRATIVO: "A",
  CENTRO_DISTRIBUICAO: "C",
  PAGAMENTO: "P",
};

//Valores para utilizar em consultas consolidadas
export const TIPO_ENTIDADE = {
  EMPRESA: "E",
  SETOR: "S",
  BANDEIRA: "B",
};

//Valores do campo tipo da tabela PESSOA
export const TIPO_ENTIDADE_PESSOA = {
  EMPRESA: "EM",
  FILIAL: "FI",
  FORNECEDOR: "FO",
};

//Valores do campo tipo da tabela PESSOA_CONTA_BANCARIA
export const TIPO_CONTA_BANCARIA = {
  CORRENTE: "C",
  POUPANCA: "P",
  GARANTIDA: "G",
};

//Valores do campo tipo da tabela CONTA_GRUPO
export const TIPO_GRUPO_CONTA = {
  PAGAMENTO: "PG",
  RECEITA: "RE",
};

//Códigos (campo codigo da tabela CONTA_GRUPO) dos grupos de conta de receita usados no filtro do dashboard de receitas.
//O cadastro de grupo de conta é global (SIIG Administrativo): os códigos são os mesmos em todos os clientes
export const CODIGO_GRUPO_CONTA_RECEITA = {
  RECEITAS_FINANCEIRAS: 2,
  OUTRAS_RECEITAS_OPERACIONAIS: 5,
};

//Códigos (campo codigo da tabela CONTA) das contas de receita usadas nos cards do dashboard de receitas.
//O cadastro de conta é global (SIIG Administrativo): os códigos são os mesmos em todos os clientes
export const CODIGO_CONTA_RECEITA = {
  RECEITAS_CONTA_CORRENTE: 31, //Card dos pagamentos conferidos (só em Outras receitas operacionais)
};

//Valores do campo tipo da tabela CONTA
export const TIPO_CONTA = {
  DESCONTO: "DE",
  DESPESA: "DF",
  JUROS: "JU",
  MULTA: "MU",
  //--
  PAGAMENTO: "PG",
  RECEITA: "RE",
  EMPRESTIMO: "EM",
  COMPRA: "CO",
  DESPESA_GERAL: "DG",
};

//Valores do campo politica_salarial da tabela CONTA (orçamento de pessoal)
export const POLITICA_SALARIAL = {
  COLABORADOR: "CO",
  CARGO: "CA",
};

//Código (campo codigo) dos grupos de conta utilizados nas regras do sistema
export const CODIGO_CONTA_GRUPO = {
  PESSOAL: 11, //Habilita a aba Orçamento pessoal no cadastro da conta
};

//Valores do campo tipo_valor da tabela SOLICITACAO_PAG_TIPO_VALOR
export const TIPO_VALOR_PAG = {
  DESCONTO: "DE",
  DESPESA: "DF",
  JUROS: "JU",
  MULTA: "MU",
};

//Valores para o tipo da movimentação do fluxo de caixa
export const TIPO_MOVIMENTACAO_FLUXO = {
  ENTRADA: "E",
  SAIDA: "S",
};

//Valores do campo tipo  da tabela SOLICITACAO
export const TIPO_SOLICITACAO = {
  PAGAMENTO: "PG",
  RECEITA: "RE",
};

//Valores do campo tipo documento (Max 5 caracteres) da tabela SOLICITACAO
// export const TIPO_DOCUMENTO_SOLICITACAO = {
//   NOTA_FISCAL: "NF",
//   NOTA_FISCAL_SERVICO: "NFS",
//   CUPOM_FISCAL: "CF",
//   CUPOM_FISCAL_IDENTIFICADO: "CFI",
//   RECIBO: "RE",
//   BOLETO: "BO",
//   FATURA: "FAT",
//   DARF: "DARF",
//   NOTA_DEBITO: "NDB",
//   GFD: "GFD",
//   TRCT: "TRCT",
//   RECIBO_FERIAS: "RF",
//   CONTRATO: "CON",
// };

export const SIGLA_TIPO_DOCUMENTO = {
  CONTRATO: "CON",
  NOTA_FISCAL: "NF",
  NOTA_FISCAL_SERVICO: "NFS",
  CUPOM_FISCAL: "CF",
  CUPOM_FISCAL_IDENTIFICADO: "CFI",
  RECIBO: "RE",
  BOLETO: "BO",
  FATURA: "FAT",
  DARF: "DARF",
};

//Siglas dos tipos de documento contemplados na leitura do documento do pagamento por IA
//OBS: Ao contemplar um tipo novo, incluir aqui e nas instruções da leitura (NotaLeituraBusiness)
export const SIGLAS_TIPO_DOCUMENTO_LEITURA_IA = [
  SIGLA_TIPO_DOCUMENTO.NOTA_FISCAL,
  SIGLA_TIPO_DOCUMENTO.NOTA_FISCAL_SERVICO,
  SIGLA_TIPO_DOCUMENTO.CUPOM_FISCAL,
  SIGLA_TIPO_DOCUMENTO.CUPOM_FISCAL_IDENTIFICADO,
  SIGLA_TIPO_DOCUMENTO.DARF,
  SIGLA_TIPO_DOCUMENTO.FATURA,
];

//Tipo retornado pela leitura do documento por IA quando o documento não é de nenhum dos tipos contemplados
export const TIPO_DOCUMENTO_LEITURA_OUTRO = "OUTRO";

//Leitura do documento do pagamento no cadastro da solicitação: a IA sugere as contas, escolhidas entre as contas que
//o usuário pode usar (envia o cadastro das contas na leitura, o que aumenta o custo de cada leitura do cadastro).
//Não vale na leitura da posse nem na do contrato. Por enquanto fixa no código; futuramente pode virar parametrização.
//Spec: documentos/specs/2026-10-27-cadastro-solicitacao-leitura-documento-ia.md (seção 11)
export const LEITURA_DOCUMENTO_SUGERIR_CONTA = true;

//Valores do campo tipo_leitura da tabela LOG_LEITURA_DOCUMENTO_IA
export const TIPO_LEITURA_DOCUMENTO_IA = {
  PAGAMENTO: "P", //documento do pagamento (posse)
  CONTRATO: "C", //contrato (aba contrato)
};

//Valores do campo situacao da tabela LOG_LEITURA_DOCUMENTO_IA
export const SITUACAO_LEITURA_DOCUMENTO_IA = {
  SUCESSO: "S",
  ERRO: "E",
};

//Retorno (status) da correção da solicitação aprovada
export const STATUS_CORRECAO_SOLICITACAO = {
  OK: "OK",
  SEM_ALTERACAO: "SEM_ALTERACAO", //nada foi alterado, então a correção não foi gravada
};

//Retorno (status) da consulta de CNPJ nos webservices
export const STATUS_CONSULTA_CNPJ = {
  OK: "OK",
  NAO_ENCONTRADO: "NAO_ENCONTRADO",
  FALHA: "FALHA", //nenhum webservice respondeu (fora do ar, limite de consulta, bloqueio)
};

//Valores do campo tipo apropriação da tabela SOLICITACAO
export const TIPO_APROPRIACAO = {
  RECEITA: "R",
  DESPESA: "D",
  ABERTURA_LOJA: "AL",
  REFORMA_LOJA: "RL",
};

//Valores do campo tipo apuração do contrato na tabela SOLICITACAO_CONTRATO
export const TIPO_APURACAO = {
  SELL_IN: "1",
  SELL_OUT: "2",
  OUTRO: "3",
};

//Valores do campo tipo lançamento do contrato na tabela SOLICITACAO_CONTRATO
export const TIPO_LANCAMENTO_CONTRATO = {
  DRE: "1", //será inativado depois
  FLUXO_CAIXA: "2", //será inativado depois
  DRE_FLUXO_CAIXA: "3", //será inativado depois
  PAG_IGUAIS_DRE_FLUXO: "4", //será ativado depois
  PAG_DIFERENTES_DRE_FLUXO: "5", //será ativado depois
};

//Valores do campo tipo anexo da tabela SOLICITACAO_ANEXO
export const TIPO_ANEXO_SOLICITACAO = {
  COTACAO: "COT",
  CONTRATO: "CON",
  OUTROS: "O",
};

//Valores do campo tipo anexo da tabela SOLICITACAO_PAG_ANEXO
export const TIPO_ANEXO_PAGAMENTO = {
  DOCUMENTO: "DOC",
  FORMA_PAGAMENTO: "FPG",
  COMPLEMENTAR: "CPL", //anexo complementar do documento
};

//Valores do campo tipo pagamento da tabela SOLICITACAO
export const TIPO_PAGAMENTO = {
  UNICO: "U",
  PARCELADO: "P",
  RECORRENTE: "R",
};

//Valores do campo tipo_valor_pagamento da tabela SOLICITACAO
export const TIPO_VALOR = {
  FIXO: "F",
  ESTIMADO: "E",
};

//Valores do campo tipo periodicidade do campo do contrato TIPO_PERIODICIDADE
export const TIPO_PERIOD_REAJUSTE = {
  DATA_BASE: "D", //determinado mês
  INTERVALO_MESES: "I", //qtde meses
};

//Valores do campo tipo vencimento da tabela SOLICITACAO
export const TIPO_VENCIMENTO = {
  DIA_FIXO: "D",
  INTERVALO_DIAS: "I",
};

//Valores do campo tipo_integracao da tabela SOLICITACAO_PAG
export const TIPO_INTEGRACAO = {
  SIIG: "1",
  CONTABILIDADE: "2",
  SIIG_CONTABILIDADE: "3",
};

//Valores do campo tipo_rateio da tabela SOLICITACAO_PAG
export const TIPO_RATEIO = {
  MANUAL: "M",
  AUTOMATICO: "A",
};

//Valores do campo forma_rateio da tabela SOLICITACAO_PAG
export const FORMA_RATEIO = {
  QUANTIDADE: "Q",
  VALOR: "V",
};

//Valores do campo tipo da tabela SOLICITACAO_APROVACAO_LOG_PAG
export const TIPO_LOG_APROVACAO = {
  NOVO: "N",
  ORIGINAL: "O",
};

//Valores do campo situacao da tabela SOLICITACAO
export const SITUACAO_SOLICITACAO = {
  PENDENTE: "P",
  PENDENTE_REAPROVACAO: "PR",
  CONTROLE: "T",
  APROVADA: "A",
  REJEITADA: "R",
  REJEITADA_REAPROVACAO: "RR",
  CANCELADA: "C",
};

//Valores do campo situacao da tabela SOLICITACAO_PAG
export const SITUACAO_PAGAMENTO = {
  PENDENTE: "P",
  PENDENTE_REAPROVACAO: "PR",
  CONTROLE: "T",
  CONFERIDO: "O",
  //REJEITADO: "R",
  REJEITADA_REAPROVACAO: "RR",
  ERRO: "E",
  SUSPENSO: "S",
  CANCELADO: "C",
};

//Valores do campo situacao da tabela SOLICITACAO_APROVACAO
export const SITUACAO_APROVACAO = {
  PENDENTE: "P",
  APROVADA: "A",
  REJEITADA: "R",
};

//Valores do campo situacao da tabela SOLICITACAO_CONFERENCIA
export const SITUACAO_CONFERENCIA = {
  CONFERIDO: "O",
  ERRO: "E",
  CANCELADA: "C",
};

//Valores do campo situacao da tabela SOLICITACAO_CONTRATO
export const SITUACAO_CONTRATO = {
  ATIVO: "A",
  SUSPENSO: "S",
  RESCINDIDO: "R",
  CANCELADO: "C",
};

//Valores do campo situacao da tabela SOLICITACAO_REAJUSTE
export const SITUACAO_REAJUSTE = {
  PENDENTE_APROVACAO: "P",
  APROVADO: "A",
  REJEITADO: "R",
};

//Valores do campo sigla da tabela FORMA_PAGAMENTO
export const SIGLA_FORMA_PAGAMENTO = {
  BOLETO: "BO", //possui tratamento
  BOLETO_DDA: "BOD", //possui tratamento
  TED: "TED", //possui tratamento
  PIX: "PIX", //possui tratamento
  CHEQUE: "CHQ", //possui tratamento
  DINHEIRO: "DIN",

  //Exclusivo despesa
  DEBITO_CONTA: "DBC", //possui tratamento
  FUNDO_FIXO_ADM: "FFA",
  FUNDO_FIXO_LOJA: "FFL",
  CARTAO_CORPORATIVO: "CCO",

  //Exclusivo receita
  DEPOSITO_CONTA: "DPC",
  DESCONTO_TITULO: "DT",
  BONIFICACAO: "BNF",
  CONTA_CORRENTE_FORNECEDOR: "FOR", //Card da forma de pagamento no dashboard de receitas
};

//Valores pré-definidos para o campo tipo da tabela SOLICITACAO_APROVACAO
export const TIPO_APROVACAO_SOL = {
  INCLUSAO: 1,
  ALTERACAO_PAGAMENTO: 2,
  EFETIVACAO_CONTROLE: 3,
  REAJUSTE_CONTRATO: 4,
  RENEGOCIACAO_CONTRATO: 5,
};

//Valores pré-definidos para o campo tipo_chave_pix da tabela FORNECEDOR
export const TIPO_CHAVE_PIX = {
  CNPJ_CPF: "C",
  EMAIL: "E",
  TELEFONE: "T",
  OUTRO: "O",
};

//IDs dos grupos dos campos do contrato da tabela CAMPO_CONTRATO_GRUPO, utilizado na carga da migration
export const ID_CAMPO_CONTRATO_GRUPO = {
  IDENTIFICACAO: 1,
  FINANCEIRO: 2,
  PARCEIRO: 3,
  VIGENCIA: 4,
};

//CAMPOS CONTRATO (ID, NOME e GRUPO)
export const CAMPO_CONTRATO = {
  //Grupo IDENTIFICACAO
  NUMERO: {
    id: 1,
    nome: "numero",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.IDENTIFICACAO,
  },
  DATA_EMISSAO: {
    id: 2,
    nome: "data_emissao",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.IDENTIFICACAO,
  },

  TIPO_OPERACAO: {
    id: 3,
    nome: "tipo_operacao",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.IDENTIFICACAO,
  },

  ACORDO: {
    id: 4,
    nome: "acordo",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.IDENTIFICACAO,
  },

  SITUACAO: {
    id: 5,
    nome: "situacao",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.IDENTIFICACAO,
  },

  //Grupo FINANCEIRO
  TIPO_LANCAMENTO: {
    id: 6,
    nome: "tipo_lancamento",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.FINANCEIRO,
  },
  TIPO_APURACAO: {
    id: 7,
    nome: "tipo_apuracao",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.FINANCEIRO,
  },

  //Grupo PARCEIRO
  LABORATORIO: {
    id: 8,
    nome: "laboratorio",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.PARCEIRO,
  },
  RESP_NOME: {
    id: 9,
    nome: "resp_negociacao_nome",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.PARCEIRO,
  },
  RESP_TELEFONE: {
    id: 10,
    nome: "resp_negociacao_tel",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.PARCEIRO,
  },
  RESP_EMAIL: {
    id: 11,
    nome: "resp_negociacao_email",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.PARCEIRO,
  },

  //Grupo Vigência
  PERIODO_VIGENCIA: {
    id: 12,
    nome: "vigencia",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  TIPO_RENOVACAO: {
    id: 13,
    nome: "tipo_renovacao",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  INDICE_REAJUSTE: {
    id: 14,
    nome: "id_indice_reajuste",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  TIPO_PERIODICIDADE: {
    id: 15,
    nome: "tipo_periodicidade",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  TIPO_PERIODICIDADE_MES: {
    id: 16,
    nome: "tipo_periodicidade_mes",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  TIPO_PERIODICIDADE_INTERVALO: {
    id: 17,
    nome: "tipo_periodicidade_intervalo",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  PRAZO_AVISO_PREVIO: {
    id: 18,
    nome: "prazo_aviso_previo",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  PRAZO_AVISO_NAO_RENOVACAO: {
    id: 19,
    nome: "prazo_aviso_nao_renov",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
  DESC_PENALIDADE: {
    id: 20,
    nome: "desc_penalidade",
    id_grupo: ID_CAMPO_CONTRATO_GRUPO.VIGENCIA,
  },
};

//IDs das parametrizações da tabela PARAMETRIZACAO
export const ID_PARAMETRIZACAO = {
  //Grupo Geral
  PAGINACAO_DEFAULT: 1,
  //  COMECE_BEM_DIA: 2,

  //Grupo Usuário
  //TIPO_IDENTIFICACAO_USUARIO: 3,
  ALTERACAO_SENHA_PRIMEIRO_ACESSO: 4,
  //EMAIL_BOAS_VINDAS: 5,

  //Grupo Reload
  RELOAD_GESTORA: 5,
  RELOAD_NOTIFICACAO: 6,

  //Grupo solicitação
  SOLICITACAO_LIMITE_VALOR: 7,
  SOLICITACAO_LIMITE_VENCIMENTO: 8,
  SOLICITACAO_REJEITADA_MAX_DIAS_REENVIO: 9,
  SOLICITACAO_LEITURA_DOCUMENTO_IA: 10,
  SOLICITACAO_DIAS_AVISO_PAG_PERTO_VENC_SEM_POSSE: 11,
  SOLICITACAO_DIAS_AVISO_PAG_VENCIDO_SEM_POSSE: 12,

  //--Parametrizações internas, que o cliente não tem permissão para alterar
  POSICAO_MENU: 996, //global: só na tabela parametrizacao, não é criada para o tenant
  AVISO_NOVA_VERSAO_ADM_SYSTEM: 997, //global: só na tabela parametrizacao, não é criada para o tenant
  BLOQUEAR_LOGIN_TODOS_USUARIOS_MANUTENCAO_SISTEMA: 998, //global: só na tabela parametrizacao, não é criada para o tenant
  BLOQUEAR_LOGIN_USUARIO_SYSTEM: 999, //global, mas pode ser criada manualmente por tenant no banco caso queira bloquear só em alguns clientes

  //-- Parametrizações de implantação, apresentadas na criação do tenant e o cliente não tem permissão para alterar --//
  INFORMAR_CODIGO_EMPRESA: 1000,
  INFORMAR_CODIGO_FILIAL: 1001,
  INFORMAR_CODIGO_FORNECEDOR: 1002,
  INFORMAR_CODIGO_CENTRO_ADM: 1003,
  CODIGO_INICIAL_CENTRO_CUSTO_ADM: 1004,
};

//IDs das autorizações da tabela AUTORIZACAO
export const ID_AUTORIZACAO = {
  //Somente system
  SYS_PARAR_SERVICO_JOB: 1,
  SYS_REINICIAR_SERVICO_JOB: 2,
  SYS_ENCERRAR_CONEXAO_BANCO_DADOS: 3,

  //Somente system e admin
  SYS_ADM_REDEFINIR_SENHA: 4,
  SYS_ADM_CANCELAMENTO_CONFERENCIA: 5,
  SYS_ADM_ALTERAR_DESC_SOLICITACAO_APROVADA: 9,

  //Tenant pode liberar
  CANCELAMENTO_SOLICITACAO: 6,
  CANCELAMENTO_PAGAMENTO: 7,
  ALTERACAO_SITUACAO_CONTRATO: 8,
};

//IDs dos tipos de notificação da tabela NOTIFICACAO_TIPO
export const ID_TIPO_NOTIFICACAO = {
  SOLICITACAO_REJEITADA: 1,
  PAGAMENTO_ERRO: 2,
  POSSE_DOCUMENTO_PENDENTE: 3,
  POSSE_DOCUMENTO_VENCIDA: 4,
};

//IDs dos tipos de numeração da tabela NUMERACAO_TIPO
export const ID_TIPO_NUMERACAO = {
  SOLICITACAO: 1,
  EMPRESA: 2,
  FILIAL: 3,
  FORNECEDOR: 4,
  CENTRO_CUSTO_ADM: 5,
};

//IDs das telas da tabela TELA (Utilizados para incluir no seeder)
//PENDENTE: VER PARA NAO CITAR O ID E SIM A ROTA. MELHOR O ID SER ID++
//OBS: Todas as rotas começam com "/" (o teste testes/frontend/telas/rotas_telas.test.jsx confere).
//     Com a barra a navegação é sempre a partir da raiz, independente da tela em que o usuário está.
export const TELAS = {
  //1- GRUPO MONITOR
  MONITOR_JOB: {
    id: 1,
    rota: "/monitor_job",
  },
  MONITOR_JOB_SUB_LOG: {
    id: 2,
    rota: "/monitor_job_log",
  },

  //2 - GRUPO GESTORA
  GESTORA_SOLICITACAO: {
    id: 10,
    rota: "/gestora_solicitacao",
  },
  GESTORA_SOLICITACAO_SUB_CAD: {
    id: 11,
    rota: "/gestora_solicitacao_cad",
  },
  GESTORA_SOLICITACAO_SUB_CORRECAO: {
    id: 13,
    rota: "/gestora_solicitacao_correcao",
  },
  GESTORA_CONTRATO: {
    id: 12,
    rota: "/gestora_contrato",
  },

  //3 - GRUPO CADASTRO
  CADASTRO_EMPRESA: {
    id: 20,
    rota: "/cadastro_empresa",
  },
  CADASTRO_FILIAL: {
    id: 21,
    rota: "/cadastro_filial",
  },
  CADASTRO_FORNECEDOR: {
    id: 22,
    rota: "/cadastro_fornecedor",
  },
  CADASTRO_CENTRO_CUSTO: {
    id: 23,
    rota: "/cadastro_centro_custo",
  },
  CADASTRO_AREA: {
    id: 24,
    rota: "/cadastro_area",
  },
  CADASTRO_FERIADO: {
    id: 25,
    rota: "/cadastro_feriado",
  },
  CADASTRO_GRUPO_PRODUTO: {
    id: 26,
    rota: "/cadastro_grupo_produto",
  },
  CADASTRO_ALCADA: {
    id: 27,
    rota: "/cadastro_alcada",
  },
  CADASTRO_CONTA_TENANT: {
    id: 28,
    rota: "/cadastro_conta_tenant",
  },

  //4 - GRUPO IMPORTACAO
  IMPORTACAO_HOME: {
    id: 30,
    rota: "/importacao",
  },
  IMPORTACAO_RESUMO_VENDA_GRUPO: {
    id: 31,
    rota: "/importacao_resumo_venda_grupo",
  },
  IMPORTACAO_QTDE_COLAB_CENTRO: {
    id: 32,
    rota: "/importacao_qtde_colab_centro",
  },
  IMPORTACAO_FORNECEDOR: {
    id: 33,
    rota: "/importacao_fornecedor",
  },
  IMPORTACAO_NOTA_FORNECEDOR: {
    id: 34,
    rota: "/importacao_nota_fornecedor",
  },
  IMPORTACAO_META_EMPRESA: {
    id: 35,
    rota: "/importacao_meta_empresa",
  },
  IMPORTACAO_RESUMO_VENDA_QTDE_CLIENTE: {
    id: 36,
    rota: "/importacao_resumo_venda_qtde_cliente",
  },

  //5 - GRUPO CONSULTA
  CONSULTA_RESUMO_VENDA: {
    id: 40,
    rota: "/consulta_resumo_venda",
  },
  CONSULTA_META: {
    id: 41,
    rota: "/consulta_meta",
  },
  CONSULTA_NOTA_ENTRADA: {
    id: 42,
    rota: "/consulta_nota_entrada",
  },
  CONSULTA_INDICE_REAJUSTE: {
    id: 43,
    rota: "/consulta_indice_reajuste",
  },

  //6 - GRUPO ACESSO
  ACESSO_PERFIL: {
    id: 50,
    rota: "/acesso_perfil",
  },
  ACESSO_USUARIO: {
    id: 51,
    rota: "/acesso_usuario",
  },
  ACESSO_LIBERACAO_TELA: {
    id: 52,
    rota: "/acesso_tela_liberacao",
    param: "idPerfil",
    link: "/acesso_tela_liberacao/0",
  },
  ACESSO_LIBERACAO_AUTORIZACAO: {
    id: 53,
    rota: "/acesso_autorizacao_liberacao",
  },
  ACESSO_LIBERACAO_AUTORIZACAO_SUB_LOG: {
    id: 54,
    rota: "/acesso_autorizacao_log",
  },
  ACESSO_LIBERACAO_NOTIFICACAO: {
    id: 55,
    rota: "/acesso_notificacao_liberacao",
  },

  //7 - GRUPO CONFIGURACAO
  CONFIG_PARAMETRIZACAO: {
    id: 60,
    rota: "/parametrizacao",
  },

  //### SYSTEM ###
  //8 - GRUPO SYSTEM - CADASTRO
  SYS_CLIENTE: {
    id: 70,
    rota: "/sys_cadastro_cliente",
  },
  SYS_PLANO_CONTA: {
    id: 71,
    rota: "/sys_cadastro_plano_conta",
  },
  SYS_GRUPO_CONTA: {
    id: 72,
    rota: "/sys_cadastro_grupo_conta",
  },
  SYS_CONTA: {
    id: 73,
    rota: "/sys_cadastro_conta",
  },
  SYS_BANCO: {
    id: 74,
    rota: "/sys_cadastro_banco",
  },
  SYS_INDICE_REAJUSTE: {
    id: 75,
    rota: "/sys_cadastro_indice_reajuste",
  },
  SYS_FORMA_PAGAMENTO: {
    id: 76,
    rota: "/sys_cadastro_forma_pagamento",
  },
  SYS_TIPO_DOCUMENTO: {
    id: 77,
    rota: "/sys_cadastro_tipo_documento",
  },
  SYS_IMPOSTO: {
    id: 78,
    rota: "/sys_cadastro_imposto",
  },

  //9 - GRUPO SYSTEM - CONSULTA
  SYS_USUARIO: {
    id: 80,
    rota: "/sys_consulta_usuario",
  },
  SYS_LOG_ALTERACAO: {
    id: 81,
    rota: "/sys_consulta_log_alteracao",
  },
  SYS_LOG_SERVIDOR: {
    id: 82,
    rota: "/sys_consulta_log_servidor",
  },
  SYS_LOG_LEITURA_DOCUMENTO_IA: {
    id: 83,
    rota: "/sys_consulta_log_leitura_documento_ia",
  },
  SYS_CHANGELOG: {
    id: 84,
    rota: "/sys_consulta_changelog",
  },
  SYS_USUARIO_CONECTADO: {
    id: 85,
    rota: "/sys_consulta_usuario_conectado",
  },

  //10 - GRUPO SYSTEM - CONFIGURACAO
  SYS_PARAM_LOG_ALTERACAO: {
    id: 90,
    rota: "/sys_param_log_alteracao",
  },
};

export const ACOES_TELA = {
  PADRAO: "P", //Acesso padrão (se não houver acesso específico é acesso total)

  //Ações comuns
  CADASTRO: "CAD",
  EXCLUIR: "DEL",

  //Ações específicas
  GESTORA_CORRECAO_SOLICITACAO: "COR",
  GESTORA_PREVISAO_POSSE: "POSSE",
  GESTORA_PREVISAO_CONFERIR: "CONF",
  GESTORA_PREVISAO_GERAR_CSV: "CSV",

  CONTRATO_EDIT: "EDIT",
  CONTRATO_REAJUSTE: "REAJUSTE",
  CONTRATO_ALT_SITUACAO: "SIT",

  FILIAL_CAD_BANDEIRA: "BAN",
  FILIAL_CAD_SETOR: "SET",
  FILIAL_CAD_ATENDIMENTO: "ATEND",

  CENTRO_CUSTO_QTDE_COLAB: "QTDCOL",

  INDICE_REAJUSTE_PERCENTUAIS: "PERC",
};

//IDs dos jobs da tabela JOB
export const ID_TIPO_JOB = {
  STATUS_SERVICO: 1,
  PREVISAO_FATURAMENTO: 2,
  AVISO_POSSE_DOCUMENTO: 3,
};

//Marca gravada no final do CSV enviado em lotes pelo backend, seguida de um JSON com os dados da geração (qtde de linhas e nome do arquivo)
//OBS: O frontend utiliza a marca para confirmar que o arquivo chegou completo e a remove antes de salvar o arquivo
export const MARCA_FIM_CSV = "#SIIG_FIM_CSV#";

//Cabeçalho da resposta do servidor que indica o bloqueio de manutenção ligado (parâmetro BLOQUEAR_LOGIN_TODOS_USUARIOS_MANUTENCAO_SISTEMA)
//OBS: Enviado no bloqueio do usuário comum (status 503) e nas respostas do system / system_dev (para apresentar a tarja de aviso)
export const HEADER_MANUTENCAO = "X-SIIG-Manutencao";

//Cabeçalho da requisição feita pela tela sem ação do usuário (ex: consulta das notificações, atualização automática).
//OBS: O servidor não atualiza a última ação do usuário na consulta de usuários conectados (SIIG Administrativo)
export const HEADER_REQUISICAO_AUTOMATICA = "X-SIIG-Automatica";
